import { gql } from 'apollo-angular';
import { contactPersonResponseFields } from '../common';

export const getEmergencyContactsQuery = gql`
  query getEmergencyContacts($contractId: String!, $type: ResidentEmergencyContactType!, $offset: Int, $limit: Int) {
    getEmergencyContacts (contractId: $contractId, type: $type, offset: $offset, limit: $limit) {
      edges {
        cursor
        node {
          ${contactPersonResponseFields}
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
`;

export const emergencyContactsExistsQuery = gql`
  query emergencyContactExists {
    emergencyContactExists {
      emergencyContactExists
    }
  }
`;
